import { ERROR_TAGS, logError } from '@gp/base'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { ErrorFallback } from '../ErrorFallback'

export const GlobalErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <ErrorBoundary
    fallback={<ErrorFallback />}
    onError={(error) => {
      logError({
        error: error as Error,
        tag: ERROR_TAGS.GLOBAL_ERROR_BOUNDARY,
        name: 'Error boundary catch',
      })
    }}
  >
    {children}
  </ErrorBoundary>
)
